<template>
  <DialogTabsContainer
    v-model="userStore.dialog"
    v-resize-observer="onResize"
    :is-loading="userStore.isLoading"
    :current-tab.sync="userStore.currentTab"
    :inline="inline"
    @close="$emit('close')"
  >
    <template #header>
      <UserDialogHeader
        :inline="inline"
        :allow-delete="canDeleteUsers"
        :allow-password-reset="canEditUsers"
        @close="$emit('close')"
      />
    </template>
    <template #v-tabs-content>
      <v-tab key="SUMMARY">SUMMARY</v-tab>
      <v-tab key="EVENTS">EVENTS</v-tab>
      <v-tab key="TICKETS">TICKETS</v-tab>

      <v-tabs-items v-model="userStore.currentTab" class="ml-2">
        <v-tab-item key="SUMMARY">
          <ERow no-gutters>
            <ECol :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12">
              <UsersDetails :user-details="userDetails" />
            </ECol>
            <v-divider :vertical="$vuetify.breakpoint.lgAndUp" />
            <ECol :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12">
              <UserAccessFeaturesSelector
                v-model="userStore.userDetails"
                :read-only="!canEditUsers"
              />
            </ECol>
          </ERow>
          <UsersProjectsTable
            v-if="canViewProjects"
            :user-id="userDetails.id"
            :company-id="userDetails.companyId"
          />
          <UsersCamerasTable
            v-if="canViewCameras"
            :allow-impersonations="canImpersonate"
            :user-id="userDetails.id"
          />
        </v-tab-item>
        <v-tab-item key="EVENTS">
          <ERow no-gutters>
            <ECol :cols="$vuetify.breakpoint.lgAndUp ? 8 : 12">
              <UsersPosthogDetails :user-details="userDetails" />
            </ECol>
          </ERow>
          <PosthogEvents
            :email="userDetails?.email"
            :is-displayed-internal-data="true"
          />
          <PosthogEventsStats :email="userDetails?.email" />
        </v-tab-item>
        <v-tab-item key="TICKETS">
          <ZohoDeskTicketsTable
            :user-email="userDetails.email"
            :height="height"
            class="px-5 pt-5"
          />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </DialogTabsContainer>
</template>

<script>
import { mapStores } from "pinia"

import { PERMISSIONS } from "@/constants/permissions"
import { useUserStore } from "@/stores/users"

import DialogTabsContainer from "@/components/DialogTabsContainer"
import UserDialogHeader from "@/components/users/UserDialogHeader"
import ZohoDeskTicketsTable from "@/components/zohoDesk/ZohoDeskTicketsTable.vue"
import UserAccessFeaturesSelector from "@/components/users/UserAccessFeaturesSelector"
import UsersDetails from "@/components/users/UsersDetails"
import UsersCamerasTable from "@/components/users/UsersCamerasTable"
import UsersPosthogDetails from "@/components/users/UsersPosthogDetails"
import UsersProjectsTable from "@/components/users/UsersProjectsTable"
import PosthogEvents from "@evercam/shared/components/posthog/PosthogEvents"
import PosthogEventsStats from "@evercam/shared/components/posthog/PosthogEventsStats"

export default {
  name: "UserDialog",
  components: {
    DialogTabsContainer,
    PosthogEvents,
    PosthogEventsStats,
    UserDialogHeader,
    UserAccessFeaturesSelector,
    UsersDetails,
    UsersCamerasTable,
    ZohoDeskTicketsTable,
    UsersPosthogDetails,
    UsersProjectsTable,
  },
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      height: undefined,
    }
  },
  computed: {
    ...mapStores(useUserStore),
    userDetails() {
      return this.userStore.userDetails
    },
    canEditUsers() {
      return this.$permissions.user.can(PERMISSIONS.USERS.UPDATE)
    },
    canDeleteUsers() {
      return this.$permissions.user.can(PERMISSIONS.USERS.DELETE)
    },
    canViewProjects() {
      return this.$permissions.user.can(PERMISSIONS.PROJECTS.VIEW)
    },
    canViewCameras() {
      return this.$permissions.user.can(PERMISSIONS.CAMERAS.VIEW)
    },
    canImpersonate() {
      return this.$permissions.user.can(PERMISSIONS.USERS.IMPERSONATE)
    },
  },
  watch: {
    inline: {
      handler(value) {
        if (value && this.userId) {
          this.userStore.fetchUserDetails(this.userId)
        }
      },
      immediate: true,
    },
  },
  methods: {
    onResize() {
      this.height = window.innerHeight - 117
    },
  },
}
</script>
